<template>
    <teleport v-for="(adapterElem, index) in adapterElements" :key="index" :to="'#' + adapterElem.elemId">
        <adapter-component v-bind="adapterElem.attrs"></adapter-component>
    </teleport>
<!--<div style="background: #b7cffa; padding: 10px;">-->
<!--        <h2>Vue Recruiter Bridge</h2>-->
<!--    {{ngStores.forms}}-->
<!--        <div v-if="ngStores.initialized && ngStores.userStore">-->
<!--            First Name: {{ngStores.userStore.activeUser.profile.VOL_FIRST_NAME}}<br/>-->
<!--            <input v-model="ngStores.userStore.activeUser.profile.VOL_FIRST_NAME"/>-->
<!--        </div>-->
<!--    </div>-->
</template>
<script>
import { errorHandler } from "@common/errorHandler/errorHandler";
import AdapterComponent from './AdapterComponent';
import "@common/syncfusionCss";
import { ngAdapterStore } from "@common/ngAdapterStore";
import { recordStore } from "@common/recordStore";
import { mapWritableState } from 'pinia';

const recruiterBridgeComponent = {
    name: 'recruiterBridge',
    data() {
        return {
            enableEditor: false,
            adapterElements: {},
            componentInterval: false,
            userSubscriptionKey: false
        };
    },
    computed: {
        ...mapWritableState(ngAdapterStore, ['ngStores']),
        recordStore() {
            return recordStore();
        },
        ngUserData() {
            return this.ngStores.userStore && this.ngStores.userStore.activeUser;
        },
        ngRoleName() {
            return this.ngUserData && this.ngUserData.roleName;
        },
        subscribedUserData() {
            let subKey = this.userSubscriptionKey;
            let roleName = this.ngRoleName;
            let userData = this.ngUserData;
            if (!subKey && roleName && roleName !== 'guest') {
                let recordId = userData && userData.ID;
                if (recordId) {
                    let fields = Object.keys(userData.profile);
                    if (fields.length) {
                        let payload = {
                            source: 'sds_getProfileField',
                            params: {
                                recordPsp: 'vol',
                                recordId: recordId,
                                fields: fields,
                            }
                        };
                        subKey = recordStore().subscribe(payload);
                        this.userSubscriptionKey = subKey;
                    }
                }
            }
            if (!subKey) return {};
            return this.recordStore.getSubscription(subKey);
        }
    },
    async mounted() {
        await ngAdapterStore().initNgStores();
        // Load components into NG App
        this.componentInterval = setInterval(() => {
            // Set components to be removed
            // Existing components will have inDOM set to true
            for (let aElemId in this.adapterElements) {
                this.adapterElements[aElemId].inDOM = false;
            }
            // Check for DOM Elements
            let domElems = document.getElementsByClassName('vue-adapter');
            // Use 'for of' for HTMLCollection
            for (let domElem of domElems) {
                let existing = this.adapterElements[domElem.id];
                // Get Attributes for use in
                let elemAttrs = {};
                domElem.getAttributeNames().forEach((attrName) => {
                    if (attrName === 'id' || attrName === 'class') return;
                    elemAttrs[attrName] = domElem.getAttribute(attrName);
                });
                // Update existing attributes and continue
                if (existing) {
                    this.adapterElements[domElem.id].inDOM = true;
                    if (existing.attrs) {
                        for (let key in existing.attrs) {
                            if (key === 'length') continue;
                            if (existing.attrs[key] !== elemAttrs[key]) {
                                existing.attrs[key] = elemAttrs[key];
                            }
                        }
                    }
                    continue;
                }
                // Check for required attributes
                let elemId = domElem.id;
                let cId = domElem.getAttribute('c-id');
                let cType = domElem.getAttribute('c-type');
                if (!elemId || !cId || !cType) {
                    errorHandler.log('Component is missing one of: id, c-id, or c-type. All are required.');
                    continue;
                }
                // Add all other attributes
                this.adapterElements[elemId] = {
                    elemId: elemId,
                    cId: cId,
                    cType: cType,
                    attrs: elemAttrs,
                    inDOM: true
                };
            }
            // Set components to be removed
            for (let aElemId in this.adapterElements) {
                if (!this.adapterElements[aElemId].inDOM) {
                    delete this.adapterElements[aElemId];
                }
            }
        }, 1000);
    },
    async beforeUnmount() {
        clearInterval(this.componentInterval);
    },
    watch: {
        roleName(role) {
            if (this.userSubscriptionKey && (!role || role === 'guest')) {
                this.recordStore.unsubscribe(this.userSubscriptionKey);
                this.userSubscriptionKey = false;
            }
        },
        subscribedUserData(fields) {
            if (!library.objIsEmpty(fields)) {
                // library.mergeObj(this.ngStores.userStore.activeUser.profile, fields);
            }
        },
        ngStores: {
            handler: function (newData) {
                ngAdapterStore().updateNgStore(newData);
            },
            deep: true // TODO might have to remove this deep watch
        }
    },
    components: {
        'adapter-component': AdapterComponent
    }
};

export default recruiterBridgeComponent;
</script>

<style lang="css">
@import "~@common/global.css";
@import "~@assets/css/utilities.css";
@import "~@assets/css/fonts.css";
</style>
